let ja = {
    "translation" : {
        "reserve": "予約する",
        "go_sharekan": "シェアカンへ"
    }
};

export default ja;